export default "__VITE_ASSET__g_nbfpwhPcnh1zQ1euV2Yw__"